<template>
    <!-- <ProjectEditor 
    :displayProjectList="false"
    :displayAnswerPage="true"
    /> -->

    <div v-if="roles" class="universal-filter-container">
        <input
        type="text"
        v-model="universalFilterText"
        placeholder="Filtrer les lignes par leur intitulé..."
        class="filter-input">
    </div>
    <!-- <div v-if="isEvaluationView">
        <label for="evaluator-comments" class="textarea-label">
            Informations à destination du Maître d'ouvrage
        </label>
        <textarea
            id="evaluator-comments"
            placeholder="Remarques du projet en entier"
            v-model="filterActiveProject.evaluators_information"
            class="question-remarques-textarea evaluator-textarea"
            @blur="updateValidatorsComment()"
        ></textarea>
    </div>
        <div v-else-if="!isEvaluationView && selectedProject && filterActiveProject && filterActiveProject.evaluators_information">
        <h3> Informations à destination du Maître d'ouvrage</h3>
        <div class="readonly-textarea" v-html="formattedDisplayLine(filterActiveProject.evaluators_information)"></div>
    </div> -->
    <h1>Données générales</h1>

    <div v-if="filteredTeam.length > 0">
        <h2>Équipe de projet</h2>
        <table class="table-data">
            <thead>
                <tr>
                    <th v-for="(header, index) in teamHeader" :key="index">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(member, index) in filteredTeam" :key="index">
                    <td style="align-self: center;">{{ member.data['entity_title'] }}</td>
                    <td v-for="(key, i) in teamInputKeys" :key="key">
                        <textarea
                            type="text"
                            class="personal-details"
                            v-model="member.data[key]"
                            :placeholder="teamHeader[i + 1]"
                            @blur="updateTeam(member, i + 1)"
                            :disabled="filterActiveProject? (filterActiveProject.status != 'EDITING' || !filterActiveProject.PC): true"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-if="filterActiveProject">
        <h2>Localisation</h2>
        <table>
            <thead>
                <tr>
                    <th>Description</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in localisationConfig" :key="item.key">
                    <td>{{ item.label }}</td>
                    <td>
                        <input 
                            class="localisation"
                            type="text" 
                            :value="filterActiveProject[item.key]" 
                            @change="updateLocationData(item.key, $event.target.value)"
                            :disabled="filterActiveProject.status != 'EDITING' || !filterActiveProject.PC"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-for="(chapter, index) in chapters" :key="index">
        <div v-if="shouldShowChapter(chapter)">
            <h2>{{ chapter }}</h2>
            <table class="chapter-table">
                <thead>
                    <!-- desc -->
                    <tr>
                        <th>&nbsp;</th>
                        <th v-for="col in generalDataConfigByChapter(chapter).columns" :key="col.tag">
                            {{ col.description }}
                        </th>
                    </tr>
                    <tr>
                        <th>&nbsp;</th>
                        <th v-for="col in generalDataConfigByChapter(chapter).columns" :key="col.tag" v-html="col.symbol + (col.unit ? ' [' + col.unit + ']' : '')">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, subIndex) in filteredChapterData(chapter).rows" :key="row.title" class="only">
                        <td class="real-title">{{ row.title }} </td>
                        <td v-for="col in generalDataConfigByChapter(chapter).columns" :key="col.tag" class="real-data">
                            <select 
                                v-if="col.type === 'dropdown'" 
                                v-model="row[col.tag]" 
                                :value="formatNumberWithSeparator(row[col.tag])"
                                :placeholder="col.tag" 
                                @change="updateValues(col.item, row, subIndex)"
                                :disabled="filterActiveProject? (filterActiveProject.status != 'EDITING' || !filterActiveProject.PC): true"
                                >
                                <option v-for="option in col.dropdown" :key="option.value" :value="option.value">{{ option.text }}</option>
                            </select>
                            <input v-else
                                class="number-input"
                                type="text"
                                :value="formatNumberWithSeparator(row[col.tag])"
                                @focus="$event.target.value = row[col.tag]"
                                :placeholder="row[col.tag]" 
                                @blur="updateValuesRow(col.item, subIndex, $event.target.value)"
                                :disabled="filterActiveProject? (filterActiveProject.status != 'EDITING' || !filterActiveProject.PC): true"
                            />
                            </td>
                    </tr>
                </tbody>
        
                <tbody>
                    <tr v-for="single in filteredChapterData(chapter).singles" :key="single.tag" :class="{ 'comment': single.type == 'text' || single.type != 'number'}">
                        <td v-if="single.type == 'number'">{{ single.tag }} </td>
                        <td v-else></td>
                        <td class="description-cell" v-html="single.description"/>
                        <td v-if="single.type" class="input-cell">
                            <textarea v-if="single.type === 'text'"
                                class="text"
                                type="text" 
                                v-model="single.comment" 
                                @change="updateValues(single, 0, subIndex)"
                                :disabled="filterActiveProject? (filterActiveProject.status != 'EDITING' || !filterActiveProject.PC): true"
                            />
                            <input v-if="single.type !== 'text'"
                            class="number-input"
                            type="text"
                            :value="formatNumberWithSeparator(single.value)"
                            @focus="$event.target.value = single.value"
                            :placeholder="single.tag" 
                            :disabled="single.readonly || (filterActiveProject? (filterActiveProject.status != 'EDITING' || !filterActiveProject.PC): true)"
                            @blur="updateValuesSingle(single, $event.target.value)"/>
                        </td>   
                        <td class="unit" v-html="single.unit"/>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
/* import ProjectEditor from './ProjectEditor.vue' */
import '../../assets/styles/table.css'

export default {
    name: 'GeneralDataConfig',
    /* components: {
        ProjectEditor
    }, */
    data() {
        return {
            universalFilterText: '',
            teamInputKeys: [
                'entity', 'entity_address', 'entity_zip', 'entity_city',
                'entity_name', 'entity_surname', 'entity_tel', 'entity_mail'
            ],
            chapters: [],
            teamHeader: [
                '', 'ENTITÉ ET FONCTION', 'ADRESSE', 'NPA', 'LOCALITE', 'NOM', 'PRENOM', 'TEL.', 'EMAIL'
            ],
            /*
              static ENTITY_QUALITIES = [
                "Maître de l'ouvrage",
                "Architecte",
                "Architecte paysagiste",
                "Référent dossier durabilité",
                "Ingénieur civil",
                "Ingénieur CVC",
                "Ingénieur Sanitaire",
                "Ingénieur électricité",
                "Ingénieur mobilité",
                "Ingénieur environnement",
                "Ingénieur énergie/durabilité",
                "Autre",
                "Autre",
                "Autre",
            ];
            */

            team: [
                { isSelected: false, data: { entity_quality : 'mo', entity_title : 'MAITRE DE L\'OUVRAGE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '', entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'architect', entity_title : 'ARCHITECTE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'architectland', entity_title : 'ARCHITECTE PAYSAGISTE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'referent', entity_title : 'REFERENT DOSSIER DURABILITE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'engcivil', entity_title : 'INGENIEUR CIVIL', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'engcvc', entity_title : 'INGENIEUR CVC', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'engsan', entity_title : 'INGENIEUR SANITAIRE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'engelec', entity_title : 'INGENIEUR ELECTRICITE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'engmob', entity_title : 'INGENIEUR MOBILITE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'engenv', entity_title : 'INGENIEUR ENVIRONNEMENT', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'engnrg', entity_title : 'INGENIEUR ENERGIE/DURABILITE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'other1', entity_title : 'AUTRE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'other2', entity_title : 'AUTRE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }},
                { isSelected: false, data: { entity_quality : 'other3', entity_title : 'AUTRE', entity : '', entity_address : '', entity_zip : '', entity_city : '', entity_name : '', entity_surname : '', entity_tel : '',  entity_mail : '' }}
            ],
            localisationConfig: [
                { label: 'DESCRIPTION DU PROJET', key: 'loc_denomination' },
                { label: 'NUMERO DE PARCELLE', key: 'loc_parcelle' },
                { label: 'ADRESSE', key: 'loc_address' },
                { label: 'NPA, LOCALITE', key: 'loc_zip_city' }
            ],
        }
    },
    computed: {
        ...mapState("project", ["projectData", "selectedProject", "projectTeam", "userListRightsProject", "roles", "answerQTest"]),
        ...mapGetters("project", ["generalDataConfigOrdered", "generalDataConfigByChapter", "generalDataGetChapters", "readOnlyProject", /* "isEvaluationView", */ "filterActiveProject", "formattedDisplayLine", "formatNumberWithSeparator"]),

        filteredTeam() {
            if (!this.universalFilterText) {
                return this.team
            }
            const filterLower = this.universalFilterText.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
            return this.team.filter(member => {
                const title = member.data['entity_title'] || ''
                return title.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterLower)
            })
        },

        filteredLocalisation() {
            if (!this.universalFilterText) {
                return this.localisation
            }
            const filterLower = this.universalFilterText.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
            return this.localisation.filter(item => {
                const title = item.data[0] || '';
                //console.log('filtering localisation:', title, filterLower);
                return title.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterLower)
            })
        },
        
    },
    async mounted() {
        if (!this.projectData || this.projectData.length === 0) {
            this.$store.dispatch("project/fetchProjectList")
                .catch(error => console.error("Error fetching project data:", error))
        }
        this.checkRouteParams();

        if (this.selectedProject) {
            try {
                await this.$store.dispatch("project/fetchGeneralData", { id: this.$route.params.id })
                this.chapters = this.generalDataGetChapters
            } catch (error) {
                console.error("Error loading general data config:", error)
            }
        }
        /* if (this.projectData && this.projectData.length > 0 && this.selectedProject) {
            const project = this.projectData.find(p => p.project_id === this.selectedProject);
            if (project) {
                //console.log("What do you have for localisation ? \tproject :", project, "\t\t\tthis.localisation :", this.localisation)
                this.localisation[0].data[1] = project.loc_denomination || ""
                this.localisation[1].data[1] = project.loc_parcelle || ""
                this.localisation[2].data[1] = project.loc_address || ""
                this.localisation[3].data[1] = project.loc_zip_city || ""
            }
        } */
        try {
            if(this.selectedProject){
            await this.$store.dispatch("project/fetchProjectTeam", { id: this.$route.params.id });
            this.syncTeamWithState();
            }
        } catch (error) {
            console.error("Error loading project team data:", error)
        }
        if(this.roles){
        this.loadUsers().then(() => {
            //console.log("Selected users with access", this.userListRightsProject)
        }).catch((error) => {
            console.error("Error loading user list:", error)
        })
        }
    },
    methods: {
        filteredChapterData(chapter) {
            const chapterConfig = this.generalDataConfigByChapter(chapter)
            if (!this.universalFilterText) {
                return chapterConfig
            }

            const filterLower = this.universalFilterText.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')

            const filteredRows = chapterConfig.rows.filter(row => {
                 const title = row.title || ''
                 return title.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterLower)
            })

            const filteredSingles = chapterConfig.singles.filter(single => {
                const description = single.description || ''
                /* const tag = single.tag || ''; */
                return description.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterLower)/*  ||
                       tag.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterLower); */
            })

            return {
                ...chapterConfig,
                rows: filteredRows,
                singles: filteredSingles
            }
        },

        shouldShowChapter(chapter) {
            const data = this.filteredChapterData(chapter);
            //console.log( data, "\tHere's the shouldShowChapter" )
            return data.rows.length > 0 || data.singles.length > 0
        },

        checkRouteParams() {
            if (!this.selectedProject) {
                if (this.$route.params.id) {
                    this.$store.commit("project/selectProjectMutation", parseInt(this.$route.params.id))
                } else {
                    this.$store.commit("project/selectProjectMutation", 0)
                }
            }
        },
        updateValuesSingle(item, rawValue) {
            const cleanedRawValue = rawValue.replace(/['’\s]/g, '').replace(/,/g, '.')
            const cleanValue = parseFloat(cleanedRawValue);
            //console.log("Updating single value: item.tag=", item.tag,"\ncleanedRawValue:", cleanedRawValue, "\ncleanValue:", cleanValue, "\nrawValue:",rawValue);
            
            this.$store.dispatch("project/updateGeneralData", {
                tag: item.tag,
                value: cleanValue,
                type: 'single'
            });
            this.$store.dispatch("project/fetchAllAnswers", this.$route.params.id);
        },
        updateValuesRow(item, subIndex, rawValue) {
            const cleanedRawValue = rawValue.replace(/['’\s]/g, '').replace(/,/g, '.')
            const cleanValue = parseFloat(cleanedRawValue);
            //console.log("Updating values Row: item.tag=", item.tag,"\nsubIndex :",subIndex,"\ncleanedRawValue:", cleanedRawValue, "\ncleanValue:", cleanValue, "\nrawValue:",rawValue);
            
            if (!Array.isArray(item.values)) {
                item.values = [];
            }
            item.values[subIndex] = cleanValue;
            
            //console.log("Updated values array at subIndex :", subIndex, " : " , item.values);
            this.$store.dispatch("project/updateGeneralData", {
                tag: item.tag,
                value: item.values,
                type: 'array'
            });
            this.$store.dispatch("project/fetchAllAnswers", this.$route.params.id);
        },
        updateValues(item, row, index) {
            //console.log("HERE WE GO ", item , "\n", row[item.tag],"\nIndex :", index)
            if (item.count > 0) {
                let newValue = row[item.tag];
                this.$store.commit("project/updateGeneralDataMutation", {
                    tag: item.tag,
                    value: newValue,
                    index: index,
                    type: 'multiple',
                })
                this.$store.dispatch("project/updateGeneralData", {
                    tag: item.tag,
                    value: item.values,
                });
                this.$store.dispatch("project/fetchAllAnswers", this.$route.params.id)
            } else {
                if(item.type == 'text'){
                    if(item.tag.includes('COMMENT')){
                        //console.log("INTO THE COMMENTS ", item)
                        this.$store.dispatch("project/updateGeneralData",{
                        tag: item.tag,
                        comment: item.comment,
                        type:'text',
                        index: index
                        })
                    return;    
                    }
                    //console.log("INTO THE TYPE TEXT ", item)
                    this.$store.dispatch("project/updateGeneralData",{
                    tag: item.tag,
                    comment: item.comment,
                    type:'text',
                    index: index
                    })
                    return;
                }
                this.$store.dispatch("project/updateGeneralData", { tag: item.tag, value: item.value, type: 'single' })
                this.$store.dispatch("project/fetchAllAnswers", this.$route.params.id)
            }
        },
        updateLocationData(key, newValue) {
            const payload = {
            project_id: this.selectedProject,
            [key]: newValue // Met à jour uniquement la ligne modifiée
        };

        this.$store.dispatch("project/projectUpdate", payload)
            .then(() => {
                //console.log("Project data updated successfully")
                this.$store.dispatch("project/fetchAllAnswers", this.$route.params.id)
            })
            .catch(error => console.error("Error updating project data:", error))
        },
        updateTeam(member, index) {
            this.$store.dispatch("project/updateProjectTeam", {
                project_id: this.selectedProject,
                row: member.data,
                index: index
            })
            .catch(error => console.error("Error updating project team:", error))
        },
        syncTeamWithState() {
            if (!this.projectTeam || !Array.isArray(this.projectTeam)) return
            const teamMap = new Map(this.projectTeam.map(member => [member.entity_quality, member]))
            this.team.forEach(localMember => {
                const updated = teamMap.get(localMember.data.entity_quality)
                if (updated) {
                    Object.keys(localMember.data).forEach(key => {
                        if (key !== 'entity_quality' && key !== 'entity_title' && updated[key] !== undefined) {
                            localMember.data[key] = updated[key]
                        }
                    })
                }
            })
        },
        async loadUsers() {
            /* //console.log("loadUsers called") */
            await this.$store.dispatch("project/fetchUserList", this.selectedProject)
                .then(() => {
                    //console.log("User rights", this.userListRightsProject)
                })
                .catch((error) => {
                    console.error("Error loading user list:", error)
                })
        },
        /* formatSymbolHeader(col){
            return `${col.symbol} + (${col.unit} ? ' [' + ${col.unit} + ']' : '')`
        }, */
       /*  updateValidatorsComment() {
            if (this.filterActiveProject) {
                if(this.filterActiveProject.status === 'VALIDATION' && this.filterActiveProject.PE) {
                    const payload = {
                        project_id: this.selectedProject,
                        evaluators_information: this.filterActiveProject.evaluators_information
                    }
                    this.$store.dispatch("project/projectUpdate", payload)
                    .catch(error => console.error("Error updating evaluator's comments:", error))
                }
            }
        }, */
    },
}
</script>

<style scoped>
.personal-details {
    width: 100%;
    max-width: 25vw;
    max-height: 5.5vh;
}

.universal-filter-container {
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: var(--border-radius);
    margin-bottom: 20px;
}

.universal-filter-container .filter-input {
    width: 100%;
    padding: 10px;
}

td {
    text-align: left;
}

table {
    table-layout: auto;
    width: 100%;
}

.chapter-table {
    table-layout: fixed;
    width: 100%;
}

.chapter-table thead tr th:first-child {
    width: 20%;
    min-width: 150px;
}

.chapter-table tbody > tr.only {
    display: table-row;
}

.chapter-table tbody > tr.only > td.real-title {
    width: auto;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding: 0.75rem 1rem;
    vertical-align: middle;
}

.chapter-table tbody > tr.only > td.real-data {
    vertical-align: middle;
    padding: 0.75rem 1rem;
}

.chapter-table tbody > tr.only > td.real-data select,
.chapter-table tbody > tr.only > td.real-data input {
    width: 100%;
    box-sizing: border-box;
}

tr.comment {
    display: grid;
    grid-template-columns: 1fr auto minmax(200px, 35%) auto;
    gap: 16px;
    margin: 10px auto;
    padding: 12px;
    box-sizing: border-box;
    background-color: #fdfdfd;
    justify-content: start;
    align-items: center;
}

tr.comment > td {
    padding: 2px 0;
    text-align: left;
    vertical-align: top;
}

tr.comment > td:first-child {
    padding-right: 15px;
    font-weight: 600;
    color: #111;
    align-self: start;
}

tr.comment > .description-cell {
    grid-column: 2;
    min-width: 20vw;
    max-width: 25vw;
    color: #555;
    font-size: 0.95em;
    white-space: normal;
    overflow-wrap: break-word;
}

tr.comment > .input-cell {
    grid-column: 3;
    align-self: stretch;
}

td.unit {
    /* max-width: 7vw; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
    text-align: right;
    align-self: center;
    display: flex;
    justify-content: center;
}

tr.comment > .input-cell > textarea.text {
    width: auto;
    min-height: 100px;
    min-width: 36vw;
    resize: horizontal;
    padding: 10px;
    border: 1px solid #ced4da;
    border-radius: var(--border-radius);
    font-size: 1rem;
    box-sizing: border-box;
    transition: border-color 0.2s, background-color 0.2s;
}

input[type=number],
input[type=text]{
    text-align: right;
}

input.filter-input, 
input.filter-input::-webkit-input-placeholder,
input.localisation {
    text-align: left;
}

/* @media only screen and (min-width:2540px) and (max-width: 2600px){
  tr.comment  > .description-cell {
    grid-template-columns: 1fr 10.7vw minmax(200px, 35%) auto;
  }
} */
</style>